module.exports = __webpack_public_path__ + "src/assets/img/smoke_one.f6aea2d2.svg";